import { useRef, useEffect, useState } from "preact/hooks";

// this is frontend
const API_HOST = "https://api.weddyplace.com/cus_tags";

export const useFetchTags = (reqParams) => {
  const cache = useRef({});
  const [loading, setLoading] = useState(true);
  const [tags, setTags] = useState([]);

  useEffect(() => {
    if (reqParams === "") return;
    let url = API_HOST + reqParams;

    const fetchData = async () => {
      setLoading(true);

      if (cache.current[url]) {
        const data = cache.current[url];
        setTags(data);
        setLoading(false);
      } else {
        const response = await fetch(url, {
          headers: {
            "Content-Type": "application/json",
            // Authorization: "Bearer " + JSON.parse(token),
          },
        });

        var parsedTags = [];
        const data = await response.json();
        data.forEach((d) => {
          parsedTags.push(d.name);
        });
        cache.current[url] = parsedTags;
        setTags(parsedTags);
        setLoading(false);
      }
    };
    fetchData();
  }, [reqParams]);
  return { loading, tags };
};
